import { HoverableLinkSizes } from '@paywithextend/components'
import React from 'react'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import Tooltip from 'src/components/Tooltip/Tooltip'
import { useTranslate } from 'src/localization/Trns'

interface UnavailableOptionTooltipProps {
  className?: string
  openLeft: boolean
}

const UnavailableOptionTooltip: React.FC<UnavailableOptionTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Tooltip className={props.className} openLeft={props.openLeft}>
      <p>
        {translate(
          'This feature is not currently supported for your account type. To enable this feature, contact us via our ${resourceCenter}.',
          {
            resourceCenter: (
              <ResourceCenterLink size={HoverableLinkSizes.Small} />
            ),
          },
        )}
      </p>
    </Tooltip>
  )
}

export default UnavailableOptionTooltip
